module.exports = __webpack_public_path__ + "static/riposte_logo-10a9e477837c066fe6defc2d1d3758f9.png";